import { Link } from 'react-router';

/**
 * "Your rolodex is empty" — the one empty state on the pick step whose cause
 * lies outside the grid.
 *
 * Its own file because two surfaces have to say it in the same words.
 * `RolodexPicker` renders it, because in the side sheet it is written to be
 * promoted into it will be the whole surface and the only place the planner is
 * looking. `ComposePage` renders it too, on the card and *instead of* the
 * browse disclosure, because a planner whose rolodex is empty must not have to
 * open a control labelled "(0)" — a label that argues against opening it — to
 * find the one instruction that helps her.
 *
 * The fix lives on the vendors page, so that is the whole message: there is
 * nothing on this card she can do about it.
 */
export default function RolodexEmpty() {
  return (
    <div className="space-y-1 py-6 text-center">
      <p className="text-sm text-muted-foreground">Your rolodex is empty.</p>
      <p className="text-xs text-muted-foreground">
        <Link to="/vendors" className="underline underline-offset-2">
          Add a vendor
        </Link>{' '}
        and they show up here.
      </p>
    </div>
  );
}
